import { NextRouter } from 'next/router';

export const moveToCollectionNewPagination = (
  router: NextRouter,
  pageNumber: number,
  scrollRefElement: React.RefObject<HTMLDivElement> | null
) => {
  let { slug, ...queryParameters } = router.query;
  if (slug && !Array.isArray(slug)) {
    slug = [slug];
  }

  const urlObj: {
    pathname: string;
    query: { [k: string]: string | string[] | undefined };
  } = {
    pathname: router.pathname,
    query: { slug, ...queryParameters },
  };
  if (pageNumber === 1) {
    delete urlObj.query.p;
  } else {
    urlObj.query.p = pageNumber.toString();
  }

  router.push(urlObj, undefined, {
    shallow: true,
  });

  window.scroll(0, scrollRefElement?.current?.offsetTop || 0);
};
